import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'
import DevicesFieldValuesLoader from './_load/DevicesFieldValuesLoader'

const TemplateVivoPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <DevicesFieldValuesLoader>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent templateId={parseInt(templateId)} />
        </DevicesFieldValuesLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateVivoPdfPage
